<template>
  <div class="view stats">
    <div class="left">
       <CountrySelect
       :countries="countriesList"
       :selectedCountries="selectedCountries"
       @setCountry="updateCountry"
       :colors="colors" />
       <StatsFilter
       :filterActive="filterActive"
       :filters="statsFilter"
       @updateFilter="updateFilter"
       v-if="filterActive || !$globals.isMobile" />
    </div>
    <div class="right">
        <CountryStats
        :country="getSelectedCountry()"
        v-if="currentView === 'portrait'" />

        <CountryCompare
        :country="country"
        v-if="currentView === 'comparison'"
        :rankings="getRankings()"
        :filter="curFilter"
        :selectedCountries="selectedCountries"/>

        <CountriesRanking
        :rankings="getStats()"
        :filter="curFilter"
        v-if="currentView === 'ranking'" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import CountriesRanking from '@/components/CountriesRanking.vue';
import CountryStats from '@/components/CountryStats.vue';
import CountryCompare from '@/components/CountryCompare.vue';
import CountrySelect from '@/components/CountrySelect.vue';
import StatsFilter from '@/components/StatsFilter.vue';
import { reduce } from 'lodash';

export default {
  name: 'portrait',
  components: {
    CountriesRanking,
    CountryCompare,
    CountrySelect,
    CountryStats,
    StatsFilter,
  },

  computed: {
    country() {
      if (!this.selectedCountries[0]) return '';
      const countryStat = this.$store.getters.getCountryStats(this.selectedCountry.Id, this.$route.params.year);
      countryStat.active = true;
      return countryStat;
    },
    countriesList() {
      return this.$store.getters.getCountries(this.$route.params.year);
    },
    statsFilter() {
      return this.$store.getters.getFilter;
    },
    currentView() {
      return this.$route.params.view;
    },
  },
  data: () => ({
    curFilter: {},
    filterActive: false,
    selectedCountries: [],
    selectedCountry: [],
    defaultCountry: 'de',
    countriesLimits: [2, 4],
    classHover: '',
    colors: {},
  }),
  methods: {
    updateCountry(country) {
      if (this.currentView === 'portrait') {
        this.selectedCountries = [];
        country.active = true;
        this.selectedCountries[0] = country;
      } else if (this.currentView === 'ranking') {
        this.selectedCountries = [];
        this.selectedCountries[0] = country;
      } else {
        const cIndex = _.findIndex(this.selectedCountries, { Id: country.Id });
        if (cIndex < 0) {
          if (this.selectedCountries.length == this.countriesLimits[1]) {
            this.selectedCountries.splice(cIndex, 1);
          }
          this.selectedCountries.push(country);
        } else {
          this.selectedCountries.splice(cIndex, 1);
        }

        _.forEach(this.selectedCountries, (c, i) => {
          this.selectedCountries[i].chartClass = `bullet-${i + 1}`;
        });

        this.getColors();
      }
    },

    getColors() {
      if (this.currentView === 'portrait') {
        this.colors = {
          hoverClass: 'portrait',
        };
      } else if (this.currentView === 'ranking') {
        this.colors = {
          hoverClass: 'ranking',
        };
      } else if (this.currentView === 'comparison') {
        const cIndex = (this.selectedCountries.length === 4) ? '4' : this.selectedCountries.length + 1;
        this.colors = {
          hoverClass: `color-${cIndex}`,
        };
      }
      return this.colors;
    },

    updateFilter(filter) {
      this.curFilter = filter;
    },

    getCountries() {
      _.forEach(this.selectedCountries, (sC, i) => {
        _.find(this.countriesList, (cL, j) => {
          if (sC.Id === cL.Id) {
            cL.active = true;
          } else cL.active = false;
        });
      });

      return this.countriesList;
    },
    getSelectedCountry() {
      if (this.selectedCountries[0]) {
        const curCountry = this.$store.getters.getCountryStats(this.selectedCountries[0].Id, this.$route.params.year);
        curCountry.chartClass = 'bullet-1';
        return (curCountry) || this.getDefaultCounty();
      }
    },
    getRankings() {
      if (!this.curFilter) return '';
      const stats = this.$store.getters.getRankings(this.curFilter);
      _.forEach(this.selectedCountries, (sc) => {
        const cId = sc.Id;
        _.forEach(stats, (s, index) => {
          _.find(s, (r, rIndex) => {
            if (r.countryId === cId) {
              stats[index][rIndex].active = 'true';
            }
          });
        });
      });
      return stats;
    },
    getStats() {
      let stats = this.$store.getters.getCountriesStats(this.curFilter, this.$route.params.year);

      // order by value and rang
      // stats = _.orderBy(stats, ['value', 'rang'], ['desc', 'asc'] );

      if (this.selectedCountry) {
        const cId = this.selectedCountry.Id;
        const activeStat = _.find(stats, (s, index) => {
          if (s.id === cId) {
            stats[index].selected = 'true';
          }
        });
      }
      return stats;
    },
    getDefaultCounty() {
      const country = _.find(this.countriesList, o => o.Id === this.defaultCountry);
      country.active = true;

      if (this.currentView === 'portrait') {
        country.activeClass = 'activeLand-2';
      } else if (this.currentView === 'ranking') {
        country.activeClass = 'activeLand-1';
      }

      return country;
    },
  },
  mounted() {
    this.curFilter = this.statsFilter[0];
    this.selectedCountries.push(this.getDefaultCounty());
    this.getColors();
  },
  watch: {
    currentView(v) {
      if (v === 'portrait') {
        this.filterActive = false;
        // this.curFilter
        this.selectedCountries = [];
        this.selectedCountries.push(this.selectedCountry);
      } else {
        this.filterActive = true;
        this.selectedCountries = [];
        this.selectedCountries.push(this.selectedCountry);
      }
      this.getColors();
    },
    selectedCountries(v) {
      this.selectedCountry = v[0];
    },
  },
};
</script>

<style lang="scss">
.portrait {
}
</style>
